import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWatchlistinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M14.34 10.41a2.252 2.252 0 0 1-.313 3.445 2.252 2.252 0 1 1 .313-3.445M15.75 15l-1.41-1.41M5.25 9.75h3m-3-3h6"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M14.25 7.5V5.25A2.25 2.25 0 0 0 12 3H4.5a2.25 2.25 0 0 0-2.25 2.25V12a2.25 2.25 0 0 0 2.25 2.25h3.75"
	})]
});
export default SvgWatchlistinline;
